/**
 * System administrator auth - odvojen kanal od POS user-a.
 * - Endpoint: POST /api/admin/auth/login (email + password)
 * - Token: JWT sa SYSADMIN secret-om (drugaciji od POS-a)
 * - Storage: localStorage 'admin-token' (drugaciji kljuc od POS auth-token-a)
 */
import { api } from '../api/client';

export type AdminSession = {
  token: string;
  admin: {
    id: string;
    email: string;
    fullName: string;
    role: 'admin' | 'support' | 'readonly' | 'reseller';
  };
};

const TOKEN_KEY = 'admin-token';
const SESSION_KEY = 'admin-session';

export async function adminLogin(email: string, password: string): Promise<AdminSession> {
  const result = await api.post<AdminSession>('/admin/auth/login', { email: email.trim(), password });
  localStorage.setItem(TOKEN_KEY, result.token);
  localStorage.setItem(SESSION_KEY, JSON.stringify(result));
  return result;
}

export async function checkSetupRequired(): Promise<boolean> {
  try {
    const result = await api.get<{ setupRequired: boolean }>('/admin/auth/setup-status');
    return result.setupRequired;
  } catch {
    return false;
  }
}

export async function adminInitialSetup(email: string, fullName: string, password: string): Promise<AdminSession> {
  const result = await api.post<AdminSession>('/admin/auth/setup', { email: email.trim(), fullName: fullName.trim(), password });
  localStorage.setItem(TOKEN_KEY, result.token);
  localStorage.setItem(SESSION_KEY, JSON.stringify(result));
  return result;
}

export function loadSession(): AdminSession | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export async function verifySession(): Promise<AdminSession | null> {
  try {
    const me = await api.get<any>('/admin/auth/me');
    if (!me) return null;
    return { token: localStorage.getItem(TOKEN_KEY) || '', admin: me };
  } catch {
    logout();
    return null;
  }
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(SESSION_KEY);
}
